import React, { useState } from 'react';

// Reusable supplier logo component
function SupplierLogo({ supplier, logoPath }) {
  const [logoError, setLogoError] = useState(false);

  return (
    <div className="engine-logo-item">
      {logoError ? (
        <div className="engine-logo-placeholder">
          <span className="logo-text">{supplier}</span>
        </div>
      ) : (
        <img
          src={logoPath}
          alt={`${supplier} logo`}
          className="engine-logo"
          onError={() => setLogoError(true)}
        />
      )}
    </div>
  );
}

function EngineCard({
  engineFamily,
  variants,
  thrust,
  bypassRatio,
  pressureRatio,
  logoPath,
  suppliers
}) {
  // Support both single supplier (legacy) and multiple suppliers
  const supplierList = suppliers || [{ name: engineFamily, logoPath }];
  const supplierNames = supplierList.map(s => s.name).join(' & ');

  return (
    <div className="engine-card">
      <div className={`engine-logo-container ${supplierList.length > 1 ? 'engine-logo-container-multi' : ''}`}>
        {supplierList.map((sup, index) => (
          <SupplierLogo key={index} supplier={sup.name} logoPath={sup.logoPath} />
        ))}
      </div>

      <div className="engine-stats">
        <div className="stat-item">
          <span className="stat-label">Engine Supplier{supplierList.length > 1 ? 's' : ''}</span>
          <span className="stat-value">{supplierNames}</span>
        </div>

        {engineFamily && (
          <div className="stat-item">
            <span className="stat-label">Engine Family</span>
            <span className="stat-value">{engineFamily}</span>
          </div>
        )}

        {variants && (
          <div className="stat-item">
            <span className="stat-label">Variants</span>
            <span className="stat-value">{variants}</span>
          </div>
        )}

        {thrust && (
          <div className="stat-item">
            <span className="stat-label">Max Takeoff Thrust</span>
            <span className="stat-value">{thrust}</span>
          </div>
        )}

        {bypassRatio && (
          <div className="stat-item">
            <span className="stat-label">Bypass Ratio</span>
            <span className="stat-value">{bypassRatio}</span>
          </div>
        )}

        {pressureRatio && (
          <div className="stat-item">
            <span className="stat-label">Overall Pressure Ratio</span>
            <span className="stat-value">{pressureRatio}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default EngineCard;
